import React from "react";
import { connect } from "react-redux";

import LeftPanel from "../common/leftPanel";
import styles from './metricsv2.module.css';
import { IApplicationState, IMetricsState } from "../../../../../models/applicationState";
import IMetricsActions, * as metricActions from "../../../../../redux/actions/metricActions";
import { RouteComponentProps } from "react-router-dom";
import { bindActionCreators } from "redux";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment";



interface IMetricsv2PageState {
    processor: string;
    source: string;
    clientId: string;
    vendor: string;
    startDate: Date | null;
    endDate: Date | null;
    guidKey: string;
    page: number;
    totalPages: number;
}
interface IMetricsv2PageProps  extends RouteComponentProps, React.Props<Metricsv2Page> {
    metricActions: IMetricsActions,
    metricState: IMetricsState
}

function mapStateToProps(state: IApplicationState) {
    return {
        metricState: state.metricState
    }
}

function mapDispatchToProps(dispatch) {
    return {
        metricActions: bindActionCreators(metricActions, dispatch)
    }
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Metricsv2Page extends React.Component<IMetricsv2PageProps, IMetricsv2PageState> {
    itemsPerPage: number = 15;
    token = '';

    constructor(props: IMetricsv2PageProps) {
        super(props);

        this.state = {
            processor: "",
            source: "",
            clientId: "",
            vendor: "",
            startDate: null,
            endDate: null, 
            guidKey: this.generateGUID(),
            page: 1,
            totalPages: 0
        }

        this.onProcessorChange = this.onProcessorChange.bind(this);
        this.onClientChange = this.onClientChange.bind(this);
        this.onSourceChange = this.onSourceChange.bind(this);
        //this.onSearchTextChange = this.onSearchTextChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
        this.renderPageNumbers = this.renderPageNumbers.bind(this);
        this.onClear = this.onClear.bind(this);
    }

    componentDidMount(): void {
        let url = new URL(window.location.href);        
        this.token = url.searchParams.get("t");
        if (!this.token) {
            this.token = JSON.parse(localStorage.getItem('hatchet-t')) || '';
        }
        this.props.metricActions.getMetricsV2(1, this.itemsPerPage, "", "", "", "", null, null, this.token, true);
        //this.props.metricActions.getAutoLabelModelMetricsOptions();
    }

    componentDidUpdate(prevProps: Readonly<IMetricsv2PageProps>, prevState: Readonly<IMetricsv2PageState>, snapshot?: any): void {
        if (prevProps.metricState && this.props.metricState &&
            JSON.stringify(prevProps.metricState.metricsV2List) !== JSON.stringify(this.props.metricState.metricsV2List)) {
            const total = this.props.metricState.totalMetricsV2;
            let totalPages = Math.ceil(total / this.itemsPerPage);
            this.setState({ guidKey: this.generateGUID(), totalPages: totalPages });
        }
    }

    generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    onProcessorChange(event) {  
        this.setState({ processor: event.target.value });
    }

    onClientChange(event) {
        this.setState({ clientId: event.target.value });
    }

    onSourceChange(event) {
        this.setState({ source: event.target.value });
    }

    // onSearchTextChange(event) {
    //     this.setState({ searchText: event.target.value });
    // }

    onSearch() {
        //this.props.metricActions.getOcrMetrics(1, this.itemsPerPage, this.state.processor, this.state.clientId, this.state.startDate, this.state.endDate, this.token);
        this.props.metricActions.getMetricsV2(1, this.itemsPerPage, this.state.source, this.state.processor, this.state.clientId, "", this.state.startDate, this.state.endDate, this.token, false);
    }

    onClear() {
        this.setState({ 
            processor: "", source: "", clientId: "", vendor: "", startDate: null, endDate: null 
        }, () => {
            this.props.metricActions.getOcrMetrics(1, this.itemsPerPage, "", "", null, null, this.token);
        });
    }

    gotoPage(page: number) {
        this.setState({ page: page });
        this.props.metricActions.getMetricsV2(page, this.itemsPerPage, this.state.source, this.state.processor, this.state.clientId, this.state.vendor, this.state.startDate, this.state.endDate, this.token, false);
    }

    renderPageNumbers() {
        if (this.props.metricState) {
            const total = this.props.metricState.totalMetricsV2;        
            let totalPages = Math.ceil(total / this.itemsPerPage);
            const { page } = this.state;
            let pages = [];
        
            // Show always the first page
            if (totalPages <= 7) {
                // Less than 7 pages, show all
                for (let i = 1; i <= totalPages; i++) {
                    pages.push(
                        <li key={i} className={`page-item-custom ${page === i ? 'active' : ''}`}>
                            <a
                                className={`page-link-custom ${page === i ? 'page-link-disabled' : ''}`}
                                href="#"
                                onClick={page === i ? (e) => e.preventDefault() : () => this.gotoPage(i)}
                            >
                                {i}
                            </a>
                        </li>
                    );
                }
            } else {
                // More than 7 pages, show first few, last few, and current surrounding pages
                pages.push(
                    <li key={1} className={`page-item-custom ${page === 1 ? 'active' : ''}`}>
                        <a
                            className={`page-link-custom ${page === 1 ? 'page-link-disabled' : ''}`}
                            href="#"
                            onClick={page === 1 ? (e) => e.preventDefault() : () => this.gotoPage(1)}
                        >
                            1
                        </a>
                    </li>
                );
        
                if (page > 4) {
                    pages.push(<li key="ellipsis1" className="page-link-custom">...</li>);
                }
        
                const startPage = Math.max(2, page - 2);
                const endPage = Math.min(totalPages - 1, page + 2);
        
                for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                        <li key={i} className={`page-item-custom ${page === i ? 'active' : ''}`}>
                            <a
                                className={`page-link-custom ${page === i ? 'page-link-disabled' : ''}`}
                                href="#"
                                onClick={page === i ? (e) => e.preventDefault() : () => this.gotoPage(i)}
                            >
                                {i}
                            </a>
                        </li>
                    );
                }
        
                if (page < totalPages - 3) {
                    pages.push(<li key="ellipsis2" className="page-link-custom">...</li>);
                }
        
                pages.push(
                    <li key={totalPages} className={`page-item-custom ${page === totalPages ? 'active' : ''}`}>
                        <a
                            className={`page-link-custom ${page === totalPages ? 'page-link-disabled' : ''}`}
                            href="#"
                            onClick={page === totalPages ? (e) => e.preventDefault() : () => this.gotoPage(totalPages)}
                        >
                            {totalPages}
                        </a>
                    </li>
                );
            }
        
            return pages;
        }
        return null;
    }
    

    render() {
        let totalItems = 0;
        if (this.props?.metricState?.totalMetricsV2) {
            totalItems = this.props.metricState.totalMetricsV2;
        }

        let totalAutoLabel = 0;
        if (this.props?.metricState?.totalAutoLabeledDoc) {
            totalAutoLabel = this.props.metricState.totalAutoLabeledDoc;
        }

        let totalModelRequest = 0;
        if (this.props?.metricState?.totalModelRequest) {
            totalModelRequest = this.props.metricState.totalModelRequest;
        }

        let minEndDate = null;
        if (this.state.startDate) {
            minEndDate = moment.utc(this.state.startDate).local().add(1, 'day').toDate();
        }
        
        
        return (
            <React.Fragment>
                <style>
                {`
                    .pagination-container-custom {
                        display: flex;
                        justify-content: center;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    }

                    .pagination-custom {
                        display: flex;
                        list-style: none;
                        padding: 0;
                    }

                    .page-item-custom {
                        margin: 0 2px;
                        background-color: grey !important; /* Set background color to grey */
                        border-radius: 0.25rem;
                    }

                    .page-link-custom {
                        display: block;
                        padding: 0.5rem 0.75rem;
                        color: #007bff;
                        text-decoration: none;
                        background-color: #babcbf !important;
                        border: 1px solid #dee2e6;
                        border-radius: 0.25rem;
                    }

                    .page-link-custom:hover {
                        color: #0056b3;
                        background-color: #e9ecef !important;
                        border-color: #dee2e6;
                    }

                    .page-link-disabled {
                        pointer-events: none;
                        color: #6c757d;
                        background-color: #e9ecef;
                        border-color: #dee2e6;
                    }
                `}
                </style>
                <div className="container-fluid">
                    <div className="row">
                        <LeftPanel active="metricsV2" history={this.props.history} />
                        <main role="main" className={`col-md-9 ml-sm-auto col-lg-10 px-4 ${styles.mainFullHeight}`}>
                            <h2>Metrics V2</h2>
                            <div className={`row ${styles.searchBar}`}>
                                <div className="col-sm-2">
                                    <select className="form-control form-control-sm" placeholder="Select Processor" value={this.state.processor} onChange={this.onProcessorChange}>
                                        <option value="">Select Processor</option>
                                        {this.props?.metricState?.processors && 
                                            this.props.metricState.processors.map((item, index) => {
                                                return <option key={index} value={item}>{item}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-2">
                                    <select className="form-control form-control-sm" placeholder="Select Client" value={this.state.clientId} onChange={this.onClientChange}>
                                        <option value="">Select Client</option>
                                        {this.props?.metricState?.clientIds && 
                                            this.props.metricState.clientIds.map((item, index) => {
                                                return <option key={index} value={item}>{item}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-2">
                                    <select className="form-control form-control-sm" placeholder="Select Source" value={this.state.source} onChange={this.onSourceChange}>
                                        <option value="">Select Source</option>
                                        {this.props?.metricState?.sources && 
                                            this.props.metricState.sources.map((item, index) => {
                                                return <option key={index} value={item}>{item}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <div className={`col-sm-4 ${styles.dateRangePicker}`}>
                                    <label className="form-control-sm" htmlFor="startDate">From</label>
                                    <DatePicker 
                                        id="startDate"
                                        placeholderText="Start Date"
                                        selected={this.state.startDate} 
                                        onChange={date => this.setState({ startDate: date })} 
                                        className='form-control form-control-sm'
                                    />                                        
                                    <label className="form-control-sm" htmlFor="startDate">To</label>
                                    <DatePicker 
                                        id="endDate"
                                        placeholderText="End Date"
                                        selected={this.state.endDate} 
                                        onChange={date => this.setState({ endDate: date })} 
                                        minDate={minEndDate}
                                        className='form-control form-control-sm'
                                    />                                    
                                </div>                                
                                <div className="col-sm-2">
                                    <button className="btn btn-primary btn-sm" onClick={this.onSearch} style={{marginRight: '3px'}}>Search</button>
                                    <button className="btn btn-sm" onClick={this.onClear}>Clear</button>
                                </div>
                            </div>
                            <div className={`row ${styles.totalItemsFound}`}>
                                {totalItems} document/ocr request(s), {totalAutoLabel} auto label(s), and {totalModelRequest} model request(s)
                            </div>
                            <div className={`row ${styles.tableContainer}`}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Processed On</th>
                                            <th scope="col">Request Id</th>
                                            <th scope="col">Filename</th>
                                            <th scope="col">Vendor</th>
                                            <th scope="col">Processor</th>
                                            <th scope="col">Client Id</th>
                                            <th scope="col">Source</th>
                                            <th scope="col">Ocr'd</th>
                                            <th scope="col">No. of Ocr Pages</th>
                                            <th scope="col">Auto Labeled</th>
                                            <th scope="col">Generate Model</th>                                            
                                        </tr>
                                    </thead>
                                    <tbody key={this.state.guidKey}>
                                        { this.props.metricState && this.props.metricState.metricsV2List  &&
                                            (
                                                this.props.metricState.metricsV2List.map(item => {        
                                                    const localDate = moment.utc(item.dateProcessed).local().format('YYYY-MM-DD hh:mm A');
                                                    return (
                                                        <tr key={item.requestId}>
                                                            <td scope="row">{localDate}</td>
                                                            <td>{item.requestId}</td>
                                                            <td>{item.fileName}</td>
                                                            <td>{item.vendor}</td>
                                                            <td>{item.processor}</td>
                                                            <td>{item.clientId}</td>
                                                            <td>{item.source}</td>
                                                            <td>{item.ocrDocument}</td>
                                                            <td>{item.ocrPages}</td>
                                                            <td>{item.autoLabeledDoc}</td>
                                                            <td>{item.modelRequest}</td>                                                            
                                                        </tr>
                                                    )
                                                })                                
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className="container-fluid">
                                    <div className="pagination-container-custom">
                                        <nav aria-label="Page navigation">
                                            <ul className="pagination-custom">
                                                <li className="page-item-custom">
                                                    <a className={`page-link-custom ${this.state.page <= 1 ? 'page-link-disabled' : ''}`} href="#" aria-label="Previous" onClick={() => this.gotoPage(this.state.page - 1)}>
                                                        <span aria-hidden="true">&laquo;</span>
                                                    </a>
                                                </li>
                                                {this.renderPageNumbers()}                                                
                                                <li className="page-item-custom">
                                                    <a className={`page-link-custom ${this.state.page >= this.state.totalPages ? 'page-link-disabled' : ''}`} href="#" aria-label="Next" onClick={() => this.gotoPage(this.state.page + 1)} >
                                                        <span aria-hidden="true">&raquo;</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>   
                        </main>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}